// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1SQHd","disabled":"FileBtn_disabled__GSbSl","warn":"FileBtn_warn__3wpyF","fade":"FileBtn_fade__c66fn"};